import { t as e } from "./AppLocales-BhP8HhaO.js";
//#region src/constants/AppPaths.ts
var t = {
	home: "/",
	backlog: "/to-plan",
	absences: "/absences",
	planning: "/planning",
	myPlanning: "/my-planning",
	signIn: "/sign-in",
	signUp: "/sign-up",
	onboardingWorkspace: "/onboarding/workspace",
	settingsProfile: "/settings/profile",
	settingsSecurity: "/settings/security",
	settingsAppearance: "/settings/appearance",
	settingsTeam: "/settings/team",
	settingsInterventionTypes: "/settings/intervention-types",
	settingsTeamsAndSkills: "/settings/teams-and-skills",
	settingsPlanning: "/settings/planning",
	settingsWorkspace: "/settings/workspace",
	settingsMembers: "/settings/members",
	settingsBilling: "/settings/billing"
}, n = "fr", r = {
	timeZone: "Europe/Paris",
	workingDays: [
		1,
		2,
		3,
		4,
		5
	],
	halfDaySlots: {
		morning: {
			start: "08:00",
			end: "12:00"
		},
		afternoon: {
			start: "13:00",
			end: "17:00"
		}
	}
}, i = "EUR", a = [
	"red",
	"ruby",
	"crimson",
	"tomato",
	"orange",
	"amber",
	"yellow",
	"lime",
	"grass",
	"green",
	"jade",
	"mint",
	"turquoise",
	"cyan",
	"sky",
	"blue",
	"iris",
	"violet",
	"purple",
	"plum",
	"pink",
	"bronze",
	"gold",
	"brown",
	"gray"
], o = {
	R1: {
		id: "planning.warning.R1",
		message: "This collaborator has overlapping interventions.",
		translations: {
			en: "This collaborator has overlapping interventions.",
			fr: "Ce collaborateur a des interventions qui se chevauchent."
		}
	},
	R2: {
		id: "planning.warning.R2",
		message: "This collaborator is assigned during an absence.",
		translations: {
			en: "This collaborator is assigned during an absence.",
			fr: "Ce collaborateur est affecté pendant une absence."
		}
	},
	R3: {
		id: "planning.warning.R3",
		message: "This planned intervention has no collaborator.",
		translations: {
			en: "This planned intervention has no collaborator.",
			fr: "Cette intervention planifiée n’a aucun collaborateur."
		}
	}
}, s = [
	{
		key: "free",
		monthlyPriceInCents: 0,
		yearlyPriceInCents: 0,
		memberLimit: null,
		collaboratorLimit: 5,
		isHighlighted: !1
	},
	{
		key: "team",
		monthlyPriceInCents: 1200,
		yearlyPriceInCents: 12e3,
		memberLimit: null,
		collaboratorLimit: 25,
		isHighlighted: !0
	},
	{
		key: "business",
		monthlyPriceInCents: 2900,
		yearlyPriceInCents: 29e3,
		memberLimit: null,
		collaboratorLimit: null,
		isHighlighted: !1
	}
], c = "Trade planning", l = "en", u = [
	"org:workspace:manage",
	"org:billing:manage",
	"org:planning:edit",
	"org:reference-data:edit"
];
//#endregion
export { e as APP_LOCALES, t as APP_PATHS, n as DEFAULT_LOCALE, r as DEFAULT_WORKSPACE_PLANNING_SETTINGS, a as PLANNING_COLORS, o as PLANNING_WARNING_MESSAGES, s as PLANS, i as PLAN_CURRENCY, c as PRODUCT_NAME, l as SOURCE_LOCALE, u as WORKSPACE_PERMISSIONS };

//# sourceMappingURL=constants.mjs.map